import React from "react";

const detectPlatform = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(ua)) return "android";
    if (/iPad|iPhone|iPod/.test(ua)) return "ios";
    if (/Macintosh/.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) return "ios"; // iPadOS masquerading as macOS
    if (/Macintosh/.test(ua)) return "macos";
    if (/Win/.test(ua)) return "windows";

    return "other";
};

const getMapUrl = (address, platform) => {
    const encoded = encodeURIComponent(address);

    switch (platform) {
        case "ios":
        case "macos":
            return `http://maps.apple.com/?q=${encoded}`;
        case "android":
        case "windows":
        case "other":
        default:
            return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
    }
};

const MapLink = ({ address, children, className = "" }) => {
    const platform = detectPlatform();
    const mapUrl = getMapUrl(address, platform);

    return (
        <a
            style={{
                color: '#0066cc',
                textDecoration: 'underline',
                cursor: 'pointer',
                fontWeight: '500'
            }}
            href={mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
        >
            {children || address}
        </a>
    );
};

export default MapLink;
